module.exports = __webpack_public_path__ + "img/model_28_ug.199fe76b.jpg";